import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShoppingCartRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2 4.2Q2 3.1 3.2 3h2.3C6.8 3 8 4 8.2 5.3v.1h20a2 2 0 0 1 2 2.4l-1.3 6.8a4.4 4.4 0 0 1-4.3 3.6h-14l.2 1.4q.2 1 1.2 1h12.8a1.2 1.2 0 1 1 0 2.4H12a3.6 3.6 0 0 1-3.5-3L5.9 5.7q0-.3-.4-.3H3.2Q2.1 5.4 2 4.2m8.1 11.6h14.5a2 2 0 0 0 2-1.6l1.1-6.4h-19zm2.3 8.8a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8m11.2 0a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8" })
});
export default SvgShoppingCartRegularIcon;
